import { Transaction } from '@george-labs.com/design-system';

import { RoundingType } from '@shared/transactions-types';

import type { IconMapping } from './types';

export const iconsByRounding: IconMapping = {
    [RoundingType.SAVING]: Transaction.EXTRA_AMOUNT_ICON.SAVINGS,
    [RoundingType.DONATION]: Transaction.EXTRA_AMOUNT_ICON.HILFREICH,
};
